import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dianying', label: '电影' },
    { to: '/category/dianshiju', label: '电视剧' },
    { to: '/category/zongyi', label: '综艺' },
    { to: '/category/duanshipin', label: '短视频' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-play-circle-fill text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-950">
              好色tv
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-foreground-950 whitespace-nowrap transition-colors cursor-pointer"
            >
              关于我们
            </Link>
            <button className="px-5 py-2 bg-primary-500 text-background-50 rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer">
              立即注册
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-800 ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="border-t border-background-200/50 my-2"></div>
            <Link
              to="/about"
              className="px-4 py-3 rounded-md text-sm font-medium text-foreground-600 hover:text-foreground-950 whitespace-nowrap transition-colors cursor-pointer"
            >
              关于我们
            </Link>
            <button className="mx-4 mt-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer">
              立即注册
            </button>
          </div>
        </div>
      )}
    </header>
  );
}